var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSonicbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0;fill:#808080;}\r\n\t.st1{fill:#808080;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.1,19.8c-0.1,0-0.2,0-0.3,0l-3.1,1.8V18c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.2,0-0.3,0l-3.1,1.8V16 c0-0.1-0.1-0.2-0.2-0.2L22,14l3.1-1.8c0.1,0,0.1-0.1,0.1-0.2s0-0.2-0.1-0.2L22,9.9l3.1-1.8c0.1,0,0.1-0.1,0.1-0.2s0-0.2-0.1-0.2 l-7-4c-0.1,0-0.2,0-0.3,0l-7,4c-0.1,0-0.1,0.1-0.1,0.2s0,0.2,0.1,0.2L14,9.9l-3.1,1.8c-0.1,0-0.1,0.1-0.1,0.2s0,0.2,0.1,0.2L14,14 l-3.1,1.8c-0.1,0-0.2,0.1-0.2,0.2v3.6l-3.1-1.8c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0.1-0.1,0.2v3.6l-3.1-1.8c-0.1,0-0.2,0-0.3,0 S3.8,19.9,3.8,20v8.1c0,0.1,0,0.2,0.1,0.2l7,4c0,0,0.1,0,0.1,0s0.1,0,0.1,0c0.1,0,0.1-0.1,0.1-0.2v-3.6l3.1,1.8c0,0,0.1,0,0.1,0 s0.1,0,0.1,0c0.1,0,0.1-0.1,0.1-0.2v-3.6l3,1.8c0,0,0,0,0.1,0.1c0,0,0.1,0,0.1,0s0.1,0,0.1,0l3.1-1.8v3.6c0,0.1,0,0.2,0.1,0.2 c0,0,0.1,0,0.1,0s0.1,0,0.1,0l3.1-1.8v3.6c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0,0.1,0s0.1,0,0.1,0l7-4.1c0.1,0,0.1-0.1,0.1-0.2V20 C32.2,19.9,32.2,19.8,32.1,19.8z M18,4.1l6.5,3.8L18,11.6l-6.5-3.8L18,4.1z M14.5,10.2l3.4,2c0,0,0.1,0,0.1,0s0.1,0,0.1,0l3.4-2 l3,1.7L18,15.7l-6.5-3.8L14.5,10.2z M17.9,16.2c0,0,0.1,0,0.1,0s0.1,0,0.1,0l3.4-1.9l3,1.7L18,19.7L11.5,16l3-1.7L17.9,16.2z  M10.7,31.7L4.3,28v-7.5l6.5,3.7V31.7z M14.2,29.7l-3-1.7v-3.9c0-0.1,0-0.2-0.1-0.2l-3.4-1.9v-3.5l6.5,3.7V29.7z M14.6,21.8 l-3.4-1.9v-3.5l6.5,3.7l0,7.5l-3-1.7V22C14.7,21.9,14.7,21.9,14.6,21.8z M21.3,21.8c-0.1,0-0.1,0.1-0.1,0.2v3.9l-3,1.7l0-7.5 l6.5-3.8v3.5L21.3,21.8z M24.9,23.8c-0.1,0-0.1,0.1-0.1,0.2V28l-3,1.7v-7.5l6.5-3.8v3.5L24.9,23.8z M31.7,27.9l-6.5,3.8v-7.5 l6.5-3.8V27.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicbox);
export default __webpack_public_path__ + "static/media/sonicbox.032c2107.svg";
export { ForwardRef as ReactComponent };